import { getSupabase } from '../lib/supabaseClient';

export async function bestEffortUnsubscribeAndDelete(): Promise<void> {
  try {
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    if (sub) {
      const endpoint = sub.endpoint;
      try {
        await sub.unsubscribe();
      } catch {}
      try {
        const sb = getSupabase();
        if (sb) {
          await sb.from('push_subscriptions').delete().eq('endpoint', endpoint);
        }
      } catch {}
    }
  } catch {
    // ignore
  }
}

export async function signOutOnThisDevice(): Promise<void> {
  await bestEffortUnsubscribeAndDelete();
  const sb = getSupabase();
  if (sb) {
    try {
      await (sb.auth as any).signOut({ scope: 'local' });
    } catch {
      // ignore
    }
  }
}

